import { render } from "./ProgramSection.vue?vue&type=template&id=16e97073"
import script from "./ProgramSection.vue?vue&type=script&lang=js"
export * from "./ProgramSection.vue?vue&type=script&lang=js"

import "./ProgramSection.vue?vue&type=style&index=0&id=16e97073&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__